import { CoverageContainerViewModel } from '@bhtp-client-web/component';

export class CoverageContainer extends CoverageContainerViewModel { }


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/coverages/coverage-container.model.ts